import { render, staticRenderFns } from "./VesselLogs.vue?vue&type=template&id=085f1d04&scoped=true"
import script from "./VesselLogs.vue?vue&type=script&lang=js"
export * from "./VesselLogs.vue?vue&type=script&lang=js"
import style0 from "./VesselLogs.vue?vue&type=style&index=0&id=085f1d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f1d04",
  null
  
)

export default component.exports